import { useState, useEffect, useCallback } from "react";
import { instanceAxiosApiFiliado } from "../dataProviders";
import useTempStorage, { KEY_COOKIE_HASH_PEDIDO } from "./useTempStorage";

const useGetPedido = () => {
  const [situacao, setSituacao] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const {cookie: hash} = useTempStorage(KEY_COOKIE_HASH_PEDIDO);

  const fetch = useCallback(() => {
    if (!hash) {
      return;
    }
    setIsLoading(true);
    instanceAxiosApiFiliado
      .get(`/public/andamento-pedido/${hash}`)
      .then((response) => {
        setIsLoading(false);
        setSituacao(response.data.pedidoFiliacao.codigoSituacaoFiliacaoAtual);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsError(true);
      });
  }, [hash]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { isLoading, isError, fetch, situacao };
};

export default useGetPedido;
